const URL_PARAMETERS = {
	accessCode: 'access_code',
	email: 'email',
	externalOfferingId: 'eoid',
	locale: 'locale',
	sizeSelect: 'sizeselect',
	userToken: 'user_token',
	voucherCode: 'vc',
};

export default URL_PARAMETERS;
